<div class="flex items-center space-x-1">
  @for (star of starsArray; track star) {
    <img
      (mouseenter)="onMouseEnter(star)"
      (mouseleave)="onMouseLeave()"
      (click)="setProductRating(star)"
      [src]="star <= getFilledStars()
              ? 'assets/icons/stars/star-filled.svg'
              : 'assets/icons/stars/star-outline.svg'"
      alt="star"
      class="w-5 h-5 cursor-pointer transition-transform hover:scale-110"
    />
  }
</div>

